import { Box, Flex } from '@chakra-ui/react';
import * as React from 'react';
import { Footer } from './Footer';
import { Navbar } from './Navbar';

export const Layout: React.FC<{
  children: React.ReactElement | React.ReactElement[];
}> = ({ children }) => (
  <Flex direction="column" flex="1">
    <Box position="fixed" top="0" left="0" right="0" zIndex={1000}>
      <Navbar />
    </Box>
    <Flex as="main" role="main" direction="column" flex="1" pt="16">
      {children}
    </Flex>
    <Footer />
  </Flex>
);
